<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view id="router-view" class="page-container"></router-view>
    </transition>
  </div>
</template>

<script>
import './styles/style-base.styl'
import './styles/form-base.styl'
export default {
  name: 'app'
}
</script>

<style>
  .fade-enter-active, .fade-leave-active {
    transition: all 0.1s linear;
    opacity: 1;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .fade-white-enter-active, .fade-white-leave-active {
    transition: opacity .1s linear;
    opacity: 1;
  }

  .fade-white-enter, .fade-white-leave-to {
    opacity: .99;
  }

  .router-enter {
    transform: translateX(100%);
  }

  .router-enter-active {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    overflow: hidden;
    transition: transform .2s ease-in-out;
  }

  .router-enter-to {
    transform: translateX(0);
  }

  .router-leave {
    transform: translateX(0);
  }

  .router-leave-active {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    overflow: hidden;
    transition: transform 0 ease-in-out;
  }

  .router-leave-to {
    transform: translateX(-100%);
  }

  .popup-enter-active, .popup-leave-active {
    transition: transform .1s linear;
    transform: translate3d(0, 0, 0)
  }

  .popup-enter, .popup-leave-to {
    transform: translate3d(0, 100%, 0)
  }
</style>
